import { WizardStepName } from 'data/ppoints/constants';
import React, { useCallback, useEffect, useState } from 'react';
import { classNames } from 'utils/class-names';
import { useWizardTitle } from '../hooks/useWizardTitle';
import { WizardStepModel } from '../models/WizardStepModel';
import { getWizardStepByName } from '../utils/ppoints/wizardStepUtils';
import styles from './WizardStepItem.module.css';

type WizardStepItemProps = {
    stepProperties: WizardStepModel;
    open: boolean;
    locked: boolean;
    onClick: (stepName: WizardStepName) => void;
};

const StepIcon: React.FC<{ done?: boolean; locked: boolean; loading: boolean }> = (props) => {
    if (props.loading) {
        return <s-spinner />;
    }
    if (props.done) {
        return <s-icon type="check-circle-filled" tone="neutral" />;
    }
    if (props.locked) {
        return <s-icon type="lock" tone="neutral" />;
    }
    return <s-icon type="check-circle" tone="neutral" />;
};

const WizardStepItem: React.FC<WizardStepItemProps> = (props) => {
    const [contentLoading, setContentLoading] = useState(false);

    const handleLoadingChange = useCallback((loading: boolean) => setContentLoading(loading), []);

    useEffect(() => {
        if (!props.open) return;

        shopify.loading(contentLoading);
        return () => shopify.loading(false);
    }, [props.open, contentLoading]);

    const handleClick = () => {
        if (props.open) {
            return;
        }
        shopify.saveBar.leaveConfirmation().then(() => {
            props.onClick?.(props.stepProperties.name);
        });
    };

    return (
        <div
            className={classNames(styles.stepItem, props.open && styles.active, props.locked && styles.locked)}
            onClick={props.locked ? undefined : handleClick}
        >
            <div className="p-1 flex gap-1" onClick={() => !props?.open && shopify.saveBar.leaveConfirmation()}>
                <span className="icon">
                    <StepIcon
                        done={props.stepProperties.done}
                        locked={props.locked}
                        loading={props.open && contentLoading}
                    />
                </span>
                {/* min-w-0: a flex item won't shrink below its content's width by default, which let wide step
                content (e.g. the rate selectors) push the whole step past the screen edge on mobile */}
                <div className="flex flex-col gap-1 flex-1 min-w-0 pr-2">
                    <s-heading>{useWizardTitle(props?.stepProperties?.name || null)}</s-heading>

                    {props?.open && !props.locked && (
                        <div id={'step-' + props.stepProperties.name}>
                            {getWizardStepByName(props.stepProperties.name || null, handleLoadingChange)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WizardStepItem;
